var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShareIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 12,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#006094",
  d: "M9.379 2.29V.886c0-.785.92-1.183 1.458-.626l3.914 4.051c.332.345.332.9 0 1.245l-3.914 4.052c-.537.556-1.458.167-1.458-.618V7.498C5.116 7.498 2.132 8.91 0 12c.853-4.414 3.41-8.827 9.379-9.71"
})));
export { SvgShareIcon as ReactComponent };
export default __webpack_public_path__ + "53f2abd728a5ed337d410b6a2e051698.svg";